import { PaginationQuery } from '../../../../../types/paginationRequestType';

type Student = {
  id: number;
  fullName: string;
  rut: string;
};

export enum PetitionPaymentStatus {
  Paid = 'paid',
  Pending = 'pending',
}

export enum PetitionStatus {
  Received = 'recibida',
  InProcess = 'en_proceso',
  Waiting = 'en_espera',
  Resolved = 'resuelta',
  Approved = 'aprobada',
  Rejected = 'rechazada',
}

type Petition = {
  campusName: string;
  createdAt: string;
  folio: number;
  paymentStatus: PetitionPaymentStatus | null;
  status: PetitionStatus;
  studyPlanVersionName: string;
  title: string;
  typeId: 'ACD' | 'OTH' | 'PAY' | 'PRO' | 'RCG' | 'REG' | 'VAL' | 'ADA';
  typeName: string;
};

type Petitions = {
  data: Petition[];
  total: number;
  total_pages: number;
};
export type Pagination = PaginationQuery;

export type PetitionsHistoryResponse = {
  student: Student;
  petitions: Petitions;
};

export type FormatedPetitions = {};

type LinkedFile = {
  id: string | number;
  name: string;
  extension: string;
  type: string;
  uploadedById: number;
  updatedAt: string;
  createdAt: string;
};

interface Base {
  id: number;
  name: string;
}
interface Schedule extends Base {}

interface Campus extends Base {}

interface StudyPlanVersion extends Base {}

interface LastUpdate {
  id: number;
  changeById: number;
  comment: string;
  changeTo: string;
  createdAt: string;
  updatedAt: string;
}

export type PetitionsDetailResponse = {
  id: number;
  title: string;
  description: string;
  linkedFiles: LinkedFile[];
  linkedFileResponse?: LinkedFile;
  voucherDownloadURL?: string;
  type: {
    id: number;
    name: string;
  };
  phone: string;
  email: string;
  studyPlanVersion: StudyPlanVersion;
  schedule: Schedule;
  campus: Campus;
  status: string;
  student: Student;
  lastUpdate: LastUpdate;
  pdfFiles: any;
  fileResponse?: any;
  createdAt: string;
  paidAt: string;
  evaluationDate?: string;
  section?: { id: number; name: string };
  payment?: string | number;
};

type Doc = {
  name: string;
  url: string;
};
export type ViewStudentsPetition = {
  description: string;
  doc?: Doc;
  docs?: Doc[];
  docResponse?: Doc;
  voucher?: {
    name: string;
    url: string;
  };
};

export interface ResponselinkedFile extends LinkedFile {
  url: string;
}
